import PropTypes from 'prop-types';

const ImagePropType = PropTypes.shape({
  url: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
});

const MetaPropType = PropTypes.shape({
  type: PropTypes.string,
  name: PropTypes.string,
  content: PropTypes.string,
  provider: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  image: ImagePropType,
});

const FAQPropType = PropTypes.shape({
  faq: PropTypes.shape({
    title: PropTypes.string,
    question: PropTypes.string,
    answer: PropTypes.string,
  }),
});

export const LandingPagePropType = PropTypes.shape({
  actions: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string,
    trigger: PropTypes.string,
    name: PropTypes.string,
    event_attributes: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.string,
    })),
  })),
  canonical_url: PropTypes.string,
  faqs: PropTypes.shape({
    questions: PropTypes.arrayOf(FAQPropType),
    title: PropTypes.string,
  }),
  section_list: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    blocks: PropTypes.arrayOf(PropTypes.shape({
      alt: PropTypes.string,
      cta_label: PropTypes.string,
      cta_url: PropTypes.string,
      description: PropTypes.string,
      image: ImagePropType,
      title: PropTypes.string,
    })),
  })),
  image_sets: PropTypes.arrayOf(PropTypes.shape({
    images: PropTypes.arrayOf(PropTypes.shape({
      alt: PropTypes.string,
      image: ImagePropType,
    })),
    name: PropTypes.string,
  })),
  meta: PropTypes.arrayOf(MetaPropType),
  product: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
    offers: PropTypes.arrayOf(PropTypes.shape({
      url: PropTypes.string,
      price: PropTypes.shape({
        currency: PropTypes.string,
        amount: PropTypes.number,
      }),
    })),
    product_images: PropTypes.arrayOf(PropTypes.shape({
      image: ImagePropType,
    })),
  }),
  quotes: PropTypes.arrayOf(PropTypes.shape({
    quote: PropTypes.shape({
      quote: PropTypes.string,
      name: PropTypes.string,
      title: PropTypes.string,
      alt: PropTypes.string,
      image: ImagePropType,
    }),
  })),
  save_headline: PropTypes.string,
  sections: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    image: ImagePropType,
    cta_label: PropTypes.string,
    cta_url: PropTypes.string,
    image_alt: PropTypes.string,
    mobile_image: ImagePropType,
  })),
  stats_headline: PropTypes.string,
  title: PropTypes.string,
  url: PropTypes.string,
});

export const AboutUsPagePropType = PropTypes.shape({
  member: PropTypes.arrayOf(PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    title: PropTypes.string,
    sort: PropTypes.string,
    link: PropTypes.string,
    bioImage: ImagePropType,
    bio: PropTypes.string,
    memberExecutiveTeam: PropTypes.boolean,
  })),
  meta: PropTypes.arrayOf(MetaPropType),
  press_coverage: PropTypes.arrayOf(PropTypes.shape({
    image: ImagePropType,
    alt: PropTypes.string,
    content: PropTypes.string,
  })),
  sections: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    cta_label: PropTypes.string,
    cta_url: PropTypes.string,
    image: ImagePropType,
    image_alt: PropTypes.string,
  })),
  title: PropTypes.string,
  url: PropTypes.string,
});
